import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _address = { coordinates: '_geoCoordinates' };
var _geoCoordinates = { latitude: 'DOUBLE', longitude: 'DOUBLE' };
var _getMetaSiteIntroDataRequest = {};
var _getMetaSiteIntroDataResponse = { introData: '_introData' };
var _getRecentIntroDataRequest = {};
var _getRecentIntroDataResponse = { introData: '_introData' };
var _introData = {
    createdDate: 'google.protobuf.Timestamp',
    address: '_address',
};
var _setMetaSiteIntroDataRequest = { introData: '_introData' };
var _setMetaSiteIntroDataResponse = {};
var _setRecentIntroDataRequest = { introData: '_introData' };
var _setRecentIntroDataResponse = {};
function resolveWixApiFunnelIntroHydraIntroDataServiceUrl(opts) {
    var domainToMappings = {
        'api._api_base_domain_': [
            {
                srcPath: '/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_api/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_api/funnel-intro-hydra-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Set Recent intro data, the one user recently completed */
export function setRecentIntroData(payload) {
    var _a = serializer(_setRecentIntroDataRequest, { _address: _address, _geoCoordinates: _geoCoordinates, _introData: _introData }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setRecentIntroDataResponse, {}).fromJSON;
    function __setRecentIntroData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_intro.v1.intro_data',
            method: 'PATCH',
            methodFqn: 'wix.api.funnel.intro.hydra.IntroDataService.SetRecentIntroData',
            url: resolveWixApiFunnelIntroHydraIntroDataServiceUrl({
                protoPath: '/v1/recent-intro-data',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setRecentIntroData.fromReq = fromReq;
    __setRecentIntroData.__isAmbassador = true;
    return __setRecentIntroData;
}
/** Get Recent intro data, the one user recently completed */
export function getRecentIntroData(payload) {
    var _a = serializer(_getRecentIntroDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getRecentIntroDataResponse, {
        _address: _address,
        _geoCoordinates: _geoCoordinates,
        _introData: _introData,
    }).fromJSON;
    function __getRecentIntroData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_intro.v1.intro_data',
            method: 'GET',
            methodFqn: 'wix.api.funnel.intro.hydra.IntroDataService.GetRecentIntroData',
            url: resolveWixApiFunnelIntroHydraIntroDataServiceUrl({
                protoPath: '/v1/recent-intro-data',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getRecentIntroData.fromReq = fromReq;
    __getRecentIntroData.__isAmbassador = true;
    return __getRecentIntroData;
}
/** Set intro data of metasite */
export function setMetaSiteIntroData(payload) {
    var _a = serializer(_setMetaSiteIntroDataRequest, { _address: _address, _geoCoordinates: _geoCoordinates, _introData: _introData }), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_setMetaSiteIntroDataResponse, {}).fromJSON;
    function __setMetaSiteIntroData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_intro.v1.intro_data',
            method: 'PATCH',
            methodFqn: 'wix.api.funnel.intro.hydra.IntroDataService.SetMetaSiteIntroData',
            url: resolveWixApiFunnelIntroHydraIntroDataServiceUrl({
                protoPath: '/v1/metasite-intro-data',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __setMetaSiteIntroData.fromReq = fromReq;
    __setMetaSiteIntroData.__isAmbassador = true;
    return __setMetaSiteIntroData;
}
/** Get intro data of metasite */
export function getMetaSiteIntroData(payload) {
    var _a = serializer(_getMetaSiteIntroDataRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getMetaSiteIntroDataResponse, {
        _address: _address,
        _geoCoordinates: _geoCoordinates,
        _introData: _introData,
    }).fromJSON;
    function __getMetaSiteIntroData(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.funnel_intro.v1.intro_data',
            method: 'GET',
            methodFqn: 'wix.api.funnel.intro.hydra.IntroDataService.GetMetaSiteIntroData',
            url: resolveWixApiFunnelIntroHydraIntroDataServiceUrl({
                protoPath: '/v1/metasite-intro-data',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getMetaSiteIntroData.fromReq = fromReq;
    __getMetaSiteIntroData.__isAmbassador = true;
    return __getMetaSiteIntroData;
}
//# sourceMappingURL=http.impl.js.map